/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

// CHILDREN
import DraggableResourceCategory from './DraggableResourceCategory'

// ASSETS
import './ResourceSectionForm.scss'

class ReorganizeResourcesForm extends Component {
  state = {
    resources: this.props.resources || [],
  }
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    const resources = this.reorder(
      this.state.resources,
      result.source.index,
      result.destination.index
    )

    const resourcesCopy = JSON.parse(JSON.stringify(resources))

    resourcesCopy.map((r, index) => {
      r.order = index
    })

    this.setState(
      {
        resources: resourcesCopy,
      },
      () => {
        this.props.updateResources(resourcesCopy)
      }
    )
  }

  grabResourceData = (resource) => {
    const resources = JSON.parse(JSON.stringify(this.state.resources))
    const resourceIndex = resources.map((r) => r.id).indexOf(resource.id)

    resources[resourceIndex].title = resource.title

    this.setState({ resources })
  }

  renderResources = () => {
    const { resources } = this.state
    const { updateResources } = this.props

    if (resources && resources.length > 0) {
      return resources.map((resource, index) => (
        <Draggable key={resource.id} draggableId={`resource_${resource.id}`} index={index}>
          {(provided, _snapshot) => (
            <div>
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <DraggableResourceCategory
                  category={resource}
                  categories={resources}
                  updateCategories={updateResources}
                  sendCategoryData={this.grabResourceData}
                />
              </div>
              {/* {provided.placeholder} */}
            </div>
          )}
        </Draggable>
      ))
    }
    return null
  }

  render() {
    const { resources } = this.state
    const { t } = this.props
    return (
      <div id='ResourceSectionForm' className='row animated fadeIn'>
        <div className='col-md-12'>
          <p>{t('resources.reorganizeResourcesForm.instructions')}</p>
        </div>

        {resources && resources.length > 0 && (
          <div className='resource-draggable-container mt-0'>
            <h3>{t('resources.reorganizeResourcesForm.arrangeResources')}</h3>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId='droppable'>
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {resources
                      ? this.renderResources(provided, snapshot)
                      : null}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}
      </div>
    )
  }
}
export default withTranslation()(ReorganizeResourcesForm)
